// Brand Slider
var swiper = new Swiper(".swiper-container", {
  slidesPerView: 3,
  slidesPerGroup: 3,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // Corrected breakpoints configuration
  breakpoints: {
    // when window width is >= 481px
    0: {
      slidesPerView: 1,
      slidesPerGroup: 1,
      autoHeight: true,
    },    
    // when window width is >= 481px
    481: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    // when window width is >= 1080px
    1080: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      autoHeight: false,
    },
  }
});
